import AffectedCasesTable from './AffectedCasesTable';
export default AffectedCasesTable;



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/AffectedCasesTable/index.js